// extracted by mini-css-extract-plugin
export default {"sectionLabel":"DurationAndCutOff_sectionLabel__MqEfW","infoIcon":"DurationAndCutOff_infoIcon__8Q9qc","numberInput":"DurationAndCutOff_numberInput__ZxSoT"};